import { FILTER_RULE_ENUMS } from '@constants';

export const getUsersFilterPayload = () => {
  return {
    type: FILTER_RULE_ENUMS.EmptyRuleType,
  };
};
